import '@babel/polyfill';
import svg4everybody from 'svg4everybody';
import gsap from 'gsap';

svg4everybody();

window.gsap = gsap;
